"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAvailable = void 0;
const mraid_commons_1 = require("../mraid-commons");
let _mraid = null;
function isAvailable() {
    if (typeof window !== 'undefined') {
        if (_mraid === null) {
            try {
                _mraid = !!(0, mraid_commons_1.findMraidWindow)(window);
            }
            catch (ignored) {
                _mraid = false;
            }
        }
        return _mraid;
    }
    else {
        return false;
    }
}
exports.isAvailable = isAvailable;
//# sourceMappingURL=mraid-pixel.js.map